export const AUTH_INTENT_REGISTER = 'register';
export const REGISTER_ENTRY_PATH = `/login?intent=${AUTH_INTENT_REGISTER}`;
/** Plan picked on a public page, read once by App after sign-up. */
export const SELECTED_PLAN_STORAGE_KEY = 'np_selected_plan';
export const REGISTER_ENTRY_BUTTON_LABEL = 'Créer mon compte';
export const AUTH_ACCESS_FEEDBACK_DELAY_MS = 10_000;
export const AUTH_ACCESS_COPY = Object.freeze({
  sessionExpired: 'Votre session a expiré. Reconnectez-vous pour accéder à votre espace.',
  delayed: 'La connexion prend trop de temps. Vérifiez votre connexion et réessayez.',
});
